import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism-dark.css';

@Component({
  name: 'bpc-css-editor',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'prism-editor': PrismEditor,
  },
})
export default class CssEditor extends mixins(AbstractField) {
  @Prop(String) readonly value: string;

  get model(): string {
    return this.value;
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  highlighter(model) {
    return highlight(model, languages.css);
  }

  // created () { }

  // mounted () {  }

  // updated () { }

  // destroyed () { }
}
